export function observer(targets, type, callback, options = {}) {
  let observer;

  if (!Array.isArray(targets)) targets = [targets];

  switch (type) {
    case 'mutation':
      observer = new MutationObserver(callback);
      targets.forEach(target => observer.observe(target, options));
      break;
    case 'intersection':
      observer = new IntersectionObserver(callback, options);
      targets.forEach(target => observer.observe(target));
      break;
    case 'resize':
      observer = new ResizeObserver(callback);
      targets.forEach(target => observer.observe(target));
      break;
    default:
      console.error('#observer The type provided is invalid.');
  }

  function stop() {
    observer.disconnect();
    observer = undefined;
  }

  return stop;
}
